import { render, staticRenderFns } from "./submission_detail.vue?vue&type=template&id=7b6312f1&scoped=true&"
import script from "./submission_detail.vue?vue&type=script&lang=ts&"
export * from "./submission_detail.vue?vue&type=script&lang=ts&"
import style0 from "./submission_detail.vue?vue&type=style&index=0&id=7b6312f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6312f1",
  null
  
)

export default component.exports